import { render, staticRenderFns } from "./multiMetaData.vue?vue&type=template&id=1ac0fad8&scoped=true"
import script from "./multiMetaData.vue?vue&type=script&lang=js"
export * from "./multiMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0fad8",
  null
  
)

export default component.exports